import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProposalService } from 'src/app/services/proposal.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormService } from 'src/app/services/form';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ProposalInternalComment } from 'src/app/models/proposal-internal-comment';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { QueryInternalCommentDTO } from 'src/app/models/internal/query-internal-comment-dto';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';

@Component({
  selector: 'app-proposal-internal-comment',
  templateUrl: './proposal-internal-comment.component.html',
  styleUrls: ['./proposal-internal-comment.component.scss']
})
export class ProposalInternalCommentComponent extends BaseGridPage implements OnInit, AfterViewInit {
  @Input() ProposalId: number;
  internalcommentList: ProposalInternalCommentComponent[];
  
  pipe = new DatePipe('en-US');
  public formErrorsInternalComments = {
    InternalComment: ''
};
internalCommentsForm: FormGroup;
    
  constructor(  private dataService: DataService,
    private fb: FormBuilder,
    private proposalService: ProposalService,
    localstorageService: LocalstorageService,
    private toastService: ToastService,
    public FormService: FormService,
    logger: NGXLogger,
    appSettings: AppSettings,
    private router: Router) 
    { 
    super(localstorageService, logger, appSettings);
    this.internalCommentsForm = this.fb.group({
      InternalComment: [null]
  });
  }

  ngOnInit() {
    this.initFilterValues();
    this.fillGrid();
  }

  fillGrid(): void {
    this.filter.Skip = this.skip;
    this.filter.Take = this.pageSize;
    this.getInternalComments(this.ProposalId);
}

getInternalComments(proposalId: number)
{
  let queryInternalCommentDTO: QueryInternalCommentDTO = new QueryInternalCommentDTO();
  queryInternalCommentDTO.ProposalId = proposalId;
  queryInternalCommentDTO.SearchFilter = this.filter;
  this.dataService
    .getProposalInternalComments(queryInternalCommentDTO)
    .subscribe((response: any) => {
      if (response != null) {
        this.internalcommentList = response.Data;
        this.gridView = of({
            data: response.Data,
            total: response.Total ? response.Total : 0,
        });
    }
});
}
saveInternalComment()
{
    let comment: ProposalInternalComment = new ProposalInternalComment();
    comment.ProposalId = +this.ProposalId;
    comment.UserName = this.localstorageService.retrieve(Constants.localStorageKeys.UserDisplayName);
    comment.Comment = this.internalCommentsForm.get('InternalComment').value;
    this.logDebug('saving comment', comment);
    this.dataService
    .addProposalInternalComment(comment)
    .subscribe(data => {
        //this.partInfo = data
        if (data != null) {
            this.toastService.success(
                'Proposal internal comment ' + Constants.SUCCESS_SAVE_GENERIC
            );
        }
        this.internalCommentsForm.get('InternalComment').setValue('');
        this.fillGrid();
    });
}

getCreatedDate(createdDate: any)
{
  if(createdDate)
  {
    createdDate += 'Z';
  const formattedDate = this.pipe.transform(createdDate, 'short');
  return formattedDate;
  }
  else
  {
    return '';
  }
}

}
